import './bootstrap';
import { createApp, h } from 'vue';
import Login from './Web/Login.vue';
import { apolloProvider } from './config/apollo';

createApp({
  render: () => h(Login),   // single-file component as root
})
.use(apolloProvider)
.mount('.web-app');